import React, { useState }
from 'react'
import { 
    Layout,
    // Table,
    Col, 
    Row,
    Button,
    // Modal,
    // Upload,
    // Popconfirm,
    Form,
    Select,
    Input,
    DatePicker,
    Radio,

} from 'antd'
// import { InboxOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../Components/Navbar/Navbar'
import AddRowTable from '../../Components/Table/AddRowTable';

// const { Search } = Input;
const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;

const AddExhibitorsPayment = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate()
  const [paymentMethod, setPaymentMethod] = useState('Cash');

  const options = [
    {
      label: 'Cash',
      value: 'Cash',
    },
    {
      label: 'Check',
      value: 'Check',
    },
    {
      label: 'Other',
      value: 'Other',
      title: 'Other',
    },
  ];

  const onChange3 = ({ target: { value } }) => {
    setPaymentMethod(value);
  };
return (
  <Layout className='page'>
      <Navbar/>
      <Layout className='content-container overflow-y'>
          <Row>
              <Col span={24} className='header-container p-4'>
                  Add Exhibitor Payment
              </Col>
          </Row>
          <Row>
              <Col span={24} className='p-4'>
                  <Form form={form} layout="vertical">
                      <Row>
                          <Col span={24} className='p-2 center'>
                              Payee Info
                          </Col>
                      </Row>
                      <Row>
                          <Col span={12} className='p-2'>
                            <Item
                              label="Name"
                              name="tradename"
                              rules={[{ required: true, message: 'Please select your Tradename' }]} // Adjusted message
                            >
                              <Select placeholder="Select a property">
                                  <Option value="property1">Tradename 1</Option>
                                  <Option value="property2">Tradename 2</Option>
                                  {/* Add more options as needed */}
                              </Select>
                            </Item>
                          </Col>
                          <Col span={12} className='p-2'>
                            
                          </Col>
                      </Row>
                    
                      <Row>
                          <Col span={24} className='p-2 center'>
                              List of Billings
                          </Col>
                      </Row>
                      <Row>
                          <Col span={24} className='p-2'>
                            <AddRowTable
                               tableHeaders={[
                                  "Particulars",
                                  "Amount",
                                  "Total Paid",
                                  "Balance",
                                  "Payment",
                                ]}
                                headerSelector={[
                                  "description",
                                  "grand_total",
                                  "total_paid",
                                  "balance",
                                  "payment",
                                ]}
                                // tableData={data}
                                // ActionBtn={(row) => ActionBtn(row)}
                                withAction={true}
                                // ActionBtn={renderActionBtn}
                                withRender={false}
                                withAddRow={true}
                            />
                       
                          </Col>
                      </Row>
                      <Row>
                          <Col span={24} className='p-2 center'>
                              Payment Details
                          </Col>
                      </Row>
                      <Row>
                          <Col span={6} className=''>
                            <Row>Grand Total</Row>
                            <Row>1,000</Row>
                          </Col>
                          <Col span={6} className=''>
                            <Row>Previous Payment</Row>
                            <Row>1,000</Row>
                          </Col>
                          <Col span={6} className=''>
                            <Row>Remaining Balance</Row>
                              <Row>1,000</Row>
                          </Col>
                          <Col span={6} className='p-1'>
                              <Item
                                  label="Payment"
                                  name="tradename"
                                  rules={[{ required: true, message: 'Please enter your Name!' }]}
                              >
                                  <TextArea rows={3}/>
                              </Item>
                          </Col>
                      </Row>
                      <Row>
                          <Col span={24} className='p-2 center'>
                              Add Payment
                          </Col>
                      </Row>
                      <Row>
                          <Col span={6} className=''>
                              <Row>Payment Total</Row>
                              <Row>1,000</Row>
                          </Col>
                          <Col span={6} className=''>
                            <Form.Item name="selectedDate" className='mt-2' label="Payment Date">
                                <DatePicker style={{width:'22vw'}}/>
                            </Form.Item>
                          </Col>
                          <Col span={6} className='p-1'>
                              <Item
                                  label="Remarks"
                                  name="tradename"
                                  rules={[{ required: true, message: 'Please enter your Name!' }]}
                              >
                                  <TextArea rows={3}/>
                              </Item>
                          </Col>
                          <Col span={6} className='center'>
                            <Radio.Group options={options} onChange={onChange3} value={paymentMethod} optionType="button" />
                          </Col>
                      </Row>
                      {
                        paymentMethod === 'Check' && (
                          <Row>
                            <Col span={6} className=''>
                              <Form.Item name="selectedDate" className='mt-2' label="Check Date">
                                  <DatePicker style={{width:'22vw'}}/>
                              </Form.Item>
                            </Col>
                            <Col span={6} className='p-2'>
                              <Item
                                    label="Check Number"
                                    name="check_number"
                                    rules={[{ required: true, message: 'Please enter your Check Number!' }]}
                                >
                                    <Input />
                                </Item>
                            </Col>
                            <Col span={6} className='p-2'>
                                <Item
                                    label="Bank Name"
                                    name="bank_name"
                                    rules={[{ required: true, message: 'Please enter your Bank Name!' }]}
                                >
                                    <Input />
                                </Item>
                            </Col>
                        </Row>
                        )
                      }
                      <Row className='btn-footer'>
                          <Col span={2} className='p-2'>
                            <Button
                              // onClick={handleAdd}
                              className='btn-header'
                            >
                              Close
                            </Button>
                          </Col>
                          <Col span={2} className='p-2'>
                            <Button
                              onClick={() => navigate('/payments')}
                              className='btn-header'
                              type='primary'
                            >
                              Save
                            </Button>
                          </Col>
                      </Row>
                  </Form>
              </Col>
          </Row>
      </Layout>
  </Layout>
)
}

export default AddExhibitorsPayment
